var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14286 0C3.46942 0 3.73214 0.27168 3.73214 0.609375V1.625H7.26786V0.609375C7.26786 0.27168 7.53058 0 7.85714 0C8.18371 0 8.44643 0.27168 8.44643 0.609375V1.625H9.42857C10.2953 1.625 11 2.35371 11 3.25V3.65625V4.875V11.375C11 12.2713 10.2953 13 9.42857 13H1.57143C0.704687 13 0 12.2713 0 11.375V4.875V3.65625V3.25C0 2.35371 0.704687 1.625 1.57143 1.625H2.55357V0.609375C2.55357 0.27168 2.81629 0 3.14286 0ZM9.82143 4.875H1.17857V11.375C1.17857 11.5984 1.35536 11.7812 1.57143 11.7812H9.42857C9.64464 11.7812 9.82143 11.5984 9.82143 11.375V4.875Z",
    fill: "#A5A7B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon-date.e696263db64f6f23e42a66fa1b95326c.svg";
export { ForwardRef as ReactComponent };